module.exports = __webpack_public_path__ + "media/images/slides/coliseum-c4d7baf189eaa332bc65b356ea2e92aa.jpg";